import React from 'react';

export interface AuthSubmitButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

export function AuthSubmitButton({
  loading = false,
  disabled,
  children,
  className = '',
  ...props
}: AuthSubmitButtonProps) {
  const classes = ['auth-submit', loading ? 'auth-submit--loading' : '', className]
    .filter(Boolean)
    .join(' ');

  const { type = 'submit', ...buttonProps } = props;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...buttonProps}
    >
      {children}
    </button>
  );
}

export default AuthSubmitButton;
